import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import MatchHome from '../views/match/index.vue'
import MatchDetail from '../views/match/detail.vue'
import MatchSignup from '../views/match/signup.vue'
import MatchReward from '../views/match/reward.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/match',
    name: 'match',
    component: MatchHome
  },
  {
    path: '/match/detail',
    name: 'matchDetail',
    component: MatchDetail
  },
  {
    path: '/match/signup',
    name: 'matchSignup',
    component: MatchSignup
  },
  {
    path: '/match/reward',
    name: 'matchReward',
    component: MatchReward
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/ldy',
    name: 'ldy',
    component: () => import('../views/ldyView.vue')
  },
  {
    path: '/yinsi',
    name: 'yinsi',
    component: () => import('../components/pc_components/yinsi')
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('../components/popularize/agreement.vue')
  },
  {
    path: '/custom',
    name: 'custom',
    component: () => import(/* webpackChunkName: "about" */ '../views/custom.vue')
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
